import type { ParsedUrlQuery } from 'querystring';

export const isInternalPath = (value: unknown): value is string =>
  typeof value === 'string' &&
  value.startsWith('/') &&
  !value.startsWith('//') &&
  // Reject characters browsers can normalize into an external URL.
  // eslint-disable-next-line no-control-regex
  !/[\\\u0000-\u001f\u007f]/.test(value);

// Next.js consumes both values when navigating. Neither may point off-site.
// Reject repeated parameters rather than validating one value and using another.
export const hasInternalRedirect = ({ next, nextAs }: ParsedUrlQuery) => {
  const targets = [next, nextAs].filter((value) => value !== undefined);
  return targets.length > 0 && targets.every(isInternalPath);
};
